import axios from "axios";
import { API_BASE_URL, API_ENDPOINTS } from "../config/api";

/**
 * 🔐 Authentication Service
 * Handles doctor invitation completion and authentication flows
 */
class AuthService {
  /**
   * 🆕 Davet linkinden kayıt tamamlama
   * @param {Object} data - Registration data
   * @param {string} data.token - Invitation token from email link
   * @param {string} data.name - Doctor's first name
   * @param {string} data.surname - Doctor's last name
   * @param {string} data.password - Password (min 6 characters)
   * @param {string} data.specialization - Medical specialization
   * @param {string} data.phone_number - Phone number
   * @returns {Promise<Object>} Response with doctor info and JWT token
   */
  completeDoctorInvitation = async (data) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}${API_ENDPOINTS.AUTH.COMPLETE_INVITATION}`,
        data
      );
      return response.data;
    } catch (error) {
      console.error("Davet tamamlama sırasında hata oluştu:", error);
      throw error;
    }
  };

  /**
   * 🔍 Davet token doğrulama (optional - token decode için)
   * @param {string} token - Invitation token
   * @returns {Promise<Object>} Token payload (email, role, tenant_id)
   */
  verifyInvitationToken = async (token) => {
    try {
      // Backend'de token verify edilecek, burada sadece decode edebiliriz
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      
      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error("Token decode hatası:", error);
      throw new Error("Geçersiz davet linki");
    }
  };

  /**
   * 💾 Login sonrası token ve user bilgilerini kaydet
   * @param {string} token - JWT token
   * @param {Object} doctor - Doctor object
   */
  saveAuthData = (token, doctor) => {
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify({
      id: doctor.id,
      email: doctor.email,
      role: doctor.role,
      tenant_id: doctor.tenant_id,
      name: doctor.name,
      surname: doctor.surname
    }));
  };

  /**
   * 🚪 Logout
   */
  logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("doctorId");
    localStorage.removeItem("languageManuallySet"); // Manuel dil tercihini temizle
  };
}

export default new AuthService();
